// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LoggerUtils$OrcaPaymentPage from "../Utilities/LoggerUtils.bs.js";

function logApiResponse(logger, uri, eventName, status, statusCode, data, isPaymentSession) {
  if (eventName === undefined) {
    return;
  }
  let match;
  switch (status) {
    case "Success" :
      match = [
        "Response",
        "INFO"
      ];
      break;
    case "Error" :
      match = [
        "Err",
        "ERROR"
      ];
      break;
    case "Exception" :
      match = [
        "NoResponse",
        "ERROR"
      ];
      break;
    case "Request" :
      match = [
        "Request",
        "INFO"
      ];
      break;
  }
  LoggerUtils$OrcaPaymentPage.logApi(eventName, statusCode, data, match[0], uri, undefined, undefined, logger, match[1], "API", isPaymentSession);
}

export {
  logApiResponse,
}
/* No side effect */
